import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://aqxyruinlvoianxgbsxx.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFxeHlydWlubHZvaWFueGdic3h4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzgzODA2MTcsImV4cCI6MjA5Mzk1NjYxN30.RCE98l7jxie1IYCAlIkl-RUgLzw2WdnJAJ-f6KoWFzg';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
